module.exports = __webpack_public_path__ + "img/team-main-02.5446d9fa.png";